import React, { useEffect, useState } from "react";
import Joyride from "react-joyride"; 
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  useTheme,
  Button,
  CircularProgress,
} from "@mui/material";
import { tokens } from "../../../../../../theme";
import { fetchJsonDynamic } from "../../../../../../data/DynamicServiceNew/jsondynamicservice";
import { customerservice } from "../../../../../../config";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import { generateAndExecuteMutation } from "../../../../../../data/Axios/DynamicService";
const base_url = customerservice.uri;
const Guarantor360 = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const guarantorId = localStorage.getItem("guarantorId");
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [Guarantordata, setGuarantorDAta] = useState([]);
  const [Businessdata, setBusinessDAta] = useState([]);
  const [nokData, setnokDAta] = useState([]);
  const [isLoadingApprove, setIsLoadingApprove] = useState(false);
  const [isLoadingReject, setIsLoadingReject] = useState(false);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
const [runTour, setRunTour] = useState(() => {
  const stored = localStorage.getItem("guarantorTourCompleted");
  return stored !== "true";
});

  const base_url = customerservice.uri;

 const [steps] = useState([
    {
      target: ".joyride-back-button",
      content: "Click here to return to the previous Guarantor list page.",
    },
    {
      target: ".joyride-title",
      content: "This is the 360° view of the selected guarantor.",
    },
    {
      target: ".joyride-photo",
      content: "Here are the ID and selfie photos for identity verification.",
    },
    {
      target: ".joyride-biodata",
      content: "This section contains the personal details of the guarantor.",
    },
    {
      target: ".joyride-verify-status",
      content: "This shows whether the guarantor's information has been verified.",
    },
  ]);

  useEffect(() => {
    const variables = {
      id: parseInt(guarantorId),
    };
    async function fetchData() {
      const data = await fetchJsonDynamic(
        "guarantorById",
        "guarantor",
        variables,
        customerservice.uri
      );
      setData(JSON.parse(data.results));
    }
    fetchData();
  }, []); // Empty array ensures it runs only once

  // Mock data

  console.log("data:", data);

  const GuarontorColumns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "FirstName", headerName: "First Name", width: 130 },
    { field: "OtherNames", headerName: "Last Name", width: 90 },
    { field: "MobileNumber", headerName: "Mobile", width: 90 },
  ];

  // Array of customer photos
  const customerPhotos = [
    {
      id: 1,
      src: `data:image/png;base64,${data?.[0]?.IdfrontPhoto}`,
      alt: "ID Front Photo",
    },
    {
      id: 2,
      src: `data:image/png;base64,${data?.[0]?.IdbackPhoto}`,
      alt: "ID Back Photo",
    },
    {
      id: 3,
      src: `data:image/png;base64,${data?.[0]?.Photo}`,
      alt: "Selfie Photo",
    },
  ];

  const handleApprove = async (customerId) => {
    try {
      setIsLoadingApprove(true); // Start loading
      const CustomerId = parseInt(customerId);
      const mutationData = {
        customerId: CustomerId,
        isApproved: true,
      };
      // Make the API call to approve the customer
      const response = await generateAndExecuteMutation(
        "approveRejectCustomer",
        mutationData,
        null,
        base_url
      );

      console.log("Customer approved:", response.data);

      // Show success notification
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Customer has been approved successfully.",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error("Error approving customer:", error);

      // Show error notification
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to approve the customer. Please try again.",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoadingApprove(false); // Stop loading
    }
  };

  const handleReject = async (customerId) => {
    try {
      setIsLoadingReject(true); // Start loading
      const CustomerId = parseInt(customerId);
      const mutationData = {
        customerId: CustomerId,
        isApproved: false,
      };
      // Make the API call to reject the customer
      const response = await generateAndExecuteMutation(
        "approveRejectCustomer",
        mutationData,
        null,
        base_url
      );

      console.log("Customer rejected:", response.data);

      // Show success notification
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Customer has been Declined successfully.",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error("Error Declining customer:", error);

      // Show error notification
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to Decline the customer. Please try again.",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoadingReject(false); // Stop loading
    }
  };

  return (
    <Box
      sx={{
        padding: 3,
        "& .MuiDataGrid-root": {
          border: "none",
        },
        "& .MuiDataGrid-cell": {
          borderBottom: "none",
        },
        "& .name-column--cell": {
          color: colors.greenAccent[300],
        },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: colors.blueAccent[700],
          borderBottom: "none",
        },
        "& .MuiDataGrid-virtualScroller": {
          backgroundColor: colors.primary[400],
        },
        "& .MuiDataGrid-footerContainer": {
          borderTop: "none",
          backgroundColor: colors.blueAccent[700],
        },
        "& .MuiCheckbox-root": {
          color: `${colors.greenAccent[200]} !important`,
        },
        "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
          color: `${colors.grey[100]} !important`,
        },
      }}
    >
         <Joyride
          steps={steps}
          run={runTour}
          showSkipButton
          continuous
          scrollToFirstStep
          styles={{
            options: {
              primaryColor: theme.palette.primary.main,
              zIndex: 10000,
            },
          }}
          callback={(data) => {
            const { status } = data;
            const finishedStatuses = ["finished", "skipped"];
            if (finishedStatuses.includes(status)) {
              localStorage.setItem("guarantorTourCompleted", "true");
              setRunTour(false);
            }
          }}
        />

      <Box className="joyride-back-button">
        <Button onClick={() => navigate(-1)} variant="contained">
          Back to Guarantor
        </Button>
      </Box>
      <Typography
        variant="h4"
        fontWeight="bold"
        textAlign="center"
        gutterBottom
      >
        Guarantor 360 View
      </Typography>
      {/* Row 1: Photos */}
      <Grid container spacing={2} justifyContent="center"  className="joyride-photo">
        {customerPhotos.map((photo) => (
          <Grid item xs={12} sm={4} key={photo.id}>
            <Card elevation={3}>
              <CardContent>
                <Box
                  component="img"
                  src={photo.src}
                  alt={photo.alt}
                  sx={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "8px",
                    objectFit: "contain",
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Row 2: Customer Biodata */}
      <Box sx={{ marginTop: 4 }} className="joyride-biodata">
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Guarantor Biodata
        </Typography>
        <Card elevation={3} sx={{ padding: 3 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            flexWrap="wrap"
            mb={2}
          >
            {/* Row 1 */}
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                First Name
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.FirstName || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Other Names
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.OtherNames || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Date of Birth
              </Typography>
              <Typography variant="body1">
                {dayjs(data?.[0]?.Dob).format("MMM DD, YYYY") || "N/A"}
              </Typography>
            </Box>
          </Box>

          {/* Row 2 */}
          <Box
            display="flex"
            justifyContent="space-between"
            flexWrap="wrap"
            mb={2}
          >
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Mobile Number
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.MobileNumber || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Customer Name
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.Customername || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                ID No / Passport
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.IdnoOrPassport || "N/A"}
              </Typography>
            </Box>
          </Box>

          {/* Row 3 */}
          <Box
            display="flex"
            justifyContent="space-between"
            flexWrap="wrap"
            mb={2}
          >
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Occupation
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.Occupation || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Permanent Residence
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.PermanentResidence || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Room Number
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.RoomNumber || 0}
              </Typography>
            </Box>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            flexWrap="wrap"
            mb={2}
          >
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Town
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.Town || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Physical Address
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.PermanentResidence || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Years Lived at Residence
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.YearsLivedAtResidence || 0}
              </Typography>
            </Box>
          </Box>
          {/* Row 4 */}
          <Box display="flex" justifyContent="space-between" flexWrap="wrap">
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Marital Status
              </Typography>
              <Typography variant="body1">
                {(data?.[0]?.MaritalStatus || 0).toLocaleString()}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                House Name
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.HouseName || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Floor Number
              </Typography>
              <Typography variant="body1">
                {(data?.[0]?.FloorNumber || 0).toLocaleString()}
              </Typography>
            </Box>
            <Box
              className="joyride-verify-status"
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Verified
              </Typography>
              <Typography
                color={data?.[0]?.Isverified ? "green" : "red"}
                variant="body1"
              >
                {data?.[0]?.Isverified ? "Verified" : "Not Verified"}
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default Guarantor360;
